import 'static/style/pages/homepage';
import bootLayout from 'static/script/app/boot/boot-layout';
import DeferLoad from 'static/script/app/ui/defer-load';
import RecentlyViewedItems from 'static/script/app/ui/recently-viewed-items';
import CarouselUI from 'static/script/app/ui/carousel-ui';
import LastChanceUI from 'static/script/app/ui/last-chance-ui';
import LastChanceService from 'static/script/app/data/last-chance-service';
import React from 'react';
import { ImageNavCarousel, TrendingTags } from 'components';
import { render } from 'react-dom';
import { inViewport, logger } from 'packages';
import { Provider } from 'react-redux';
import globalStore from 'state/configure-store';
import recommendationsMount from './startpage-recommendations-mount';
import defaultNavItems from './data';
import onReady from 'utils/on-ready';
import { MultiCurrencyBoot } from 'components';

export default async initData => {
    const homepageCategorySlider = document.querySelector(
        '[data-image-nav--carousel]'
    );
    if (homepageCategorySlider) {
        const mount = target =>
            render(
                <Provider store={globalStore}>
                    <ImageNavCarousel
                        items={defaultNavItems}
                        itm={{
                            source: 'Homepage',
                            medium: 'NavCarousel'
                        }}
                    />
                </Provider>,
                target
            );

        inViewport('[data-image-nav--carousel]', mount);
    }

    const trendingSearches = document.querySelector('[data-trending-tags]');

    if (trendingSearches && initData) {
        const mount = target =>
            render(<TrendingTags initData={initData} />, target);

        inViewport('[data-trending-tags]', mount);
    }

    // DISABLE THE MEGA MENY FOR TEST OF ENGAGEMENT
    // const megaMenu = document.querySelector('[data-mega-menu-categories]');

    // if (megaMenu) {
    //     await render(
    //         <Provider store={globalStore}>
    //             <MegaMenuCategories />
    //         </Provider>,
    //         megaMenu
    //     );
    // }

    /**
     * Define code split
     */
    if (
        initData &&
        initData.splitTests &&
        initData.splitTests['marketing-automation-recommendations']
    ) {
        try {
            recommendationsMount(initData);
        } catch (error) {
            logger(error);
        }
    }

    onReady(() => {
        bootLayout(initData);
        //DeferLoad.attachTo('[data-defer-load]');
        DeferLoad.attachTo(document);
        RecentlyViewedItems.attachTo('[data-recently-viewed-items]');
        CarouselUI.attachTo('[data-carousel]');
        LastChanceService.attachTo(document); // Load before LastChanceUI
        LastChanceUI.attachTo('[data-startpage-lazy-load-last-chance]', {
            initData: initData
        });
        MultiCurrencyBoot.boot(initData);
    });
};



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/pages/start-page/index.js